import {Box} from "@chakra-ui/react";
import Footer from '../../layouts/Footer';
import Header from '../../layouts/Header';
import LiquidityMain from '../../components/LiquidityMain';

const Liquidity = (props) => {

	return(
		<Box>
      <Header />
			<LiquidityMain/>
      <Footer />
		</Box>
	)
}

export default Liquidity;